export default __webpack_public_path__ + "static/media/road-hazard-slippery.c05f9e26.svg";